import { createContext } from 'react';
export const AdminRoutesContext = createContext({
    useAdminRoutes: false,
    isPreviewMode: false,
});
